import { BaseService } from '@/core/base-service';
import { IVariable } from '@/models/variable.model';

export default class VariableService extends BaseService<IVariable> {
  public constructor() {
    super('services/servicescard/api/variable');
  }
}
